module.exports = __webpack_public_path__ + "img/zsplus.d4ea8f73.jpg";